import { useState } from 'react';
import { Copy, Check, BadgeCheck } from 'lucide-react';
import { toast } from 'sonner';

/**
 * StoreUidBadge — small copyable pill showing the store's public UID.
 * Used in store detail hero + product detail store-strip.
 */
export default function StoreUidBadge({ store = {}, locale = 'ar', className = '' }) {
  const [copied, setCopied] = useState(false);
  const isAr = locale === 'ar';
  const uid = store.store_uid;
  if (!uid) return null;

  const doCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(uid);
      setCopied(true);
      toast.success(isAr ? 'تم النسخ' : 'Copied');
      setTimeout(() => setCopied(false), 1500);
    } catch (_) { /* ignore */ }
  };

  return (
    <button
      type="button"
      onClick={doCopy}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md
                  bg-white/10 border border-white/20 hover:bg-white/15
                  text-xs font-mono transition-colors ${className}`}
      data-testid="store-uid-badge"
    >
      {store.verified && <BadgeCheck className="h-3 w-3 text-[#1E9BD9]" />}
      <span className="text-slate-600 dark:text-slate-300">
        {isAr ? 'الرقم التعريفي:' : 'Store UID:'}
      </span>
      <span dir="ltr" className="text-[#0F172A] dark:text-white">{uid}</span>
      {copied ? <Check className="h-3 w-3 text-green-500" /> : <Copy className="h-3 w-3 opacity-60" />}
    </button>
  );
}
